import {
  createSelector,
  createRootSelector,
  createSelectorMemoized,
} from '@mui/x-data-grid-pro/internals';
import type { GridStatePremium } from '../../../models/gridStatePremium';
import type { Conversation } from './gridAiAssistantInterfaces';

const gridAiAssistantStateSelector = createRootSelector(
  (state: GridStatePremium) => state.aiAssistant,
);

export const gridAiAssistantActiveConversationIndexSelector = createSelector(
  gridAiAssistantStateSelector,
  (aiAssistant) => aiAssistant?.activeConversationIndex,
);

export const gridAiAssistantConversationsSelector = createSelector(
  gridAiAssistantStateSelector,
  (aiAssistant) => aiAssistant?.conversations,
);

export const gridAiAssistantActiveConversationSelector = createSelectorMemoized(
  gridAiAssistantConversationsSelector,
  gridAiAssistantActiveConversationIndexSelector,
  (conversations, index) => conversations[index] as Conversation | undefined,
);
